function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#9A9A9A"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.166,
  d: "M23.478 16.174v.522a.523.523 0 0 1-.521.521H1.043a.523.523 0 0 1-.521-.521v-.522l9.683-7.044L12 10.435l1.795-1.305 9.683 7.044z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.957 0H1.043C.468 0 0 .475 0 1.059v15.883C0 17.524.468 18 1.043 18h21.914c.575 0 1.043-.475 1.043-1.059V1.058C24 .476 23.532 0 22.957 0zm0 15.372l-8.275-6.107 8.275-6.108v12.215zM1.043 1.059h21.914v.79l-9.468 6.987h-.001L12 9.934l-1.488-1.098-9.469-6.988v-.79zm0 2.098l8.275 6.108-8.275 6.107V3.157zm21.914 13.784H1.043v-.26l9.163-6.762 1.488 1.098c.183.135.43.135.613 0l1.488-1.098 9.162 6.762v.26z"
}));

var SvgIcMail3 = function SvgIcMail3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMail3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_mail 3.80d55d09.svg";
export { ForwardRef as ReactComponent };